import { useTranslation } from "react-i18next";

import styles from "./StatusBadge.module.scss";

interface StatusBadgeProps {
  label: string;
  color: string;
}

const StatusBadge = ({ label, color }: StatusBadgeProps) => {
  const { t } = useTranslation();

  return (
    <span
      className={styles.badge}
      style={{ color, backgroundColor: `${color}1a` }}
    >
      {t(label)}
    </span>
  );
};

export default StatusBadge;
